import React from 'react'
import styled from 'styled-components'
import addressStyles from './address.styles'
import Typography from '../typography/typography.atom'
import StackAtom from '../../to_layout/stack/stack.atom'

interface ApAddressProps {
  ap_data_arr: {
    clientName: string
    addressLine1?: string
    addressLine2?: string
    CountryName?: string
    PostalCode?: string
  }[]
}

const apAtomName = {ap_atom_name: 'addressAtom'}

const AddressAtom = styled((props: ApAddressProps) => {
  const {clientName, addressLine1, addressLine2, CountryName, PostalCode} =
    props.ap_data_arr[0]
  return (
    <StackAtom ap_type="column" {...props} {...apAtomName}>
      <Typography ahd_type="fData">
        {clientName}
        <br />
        {addressLine1}
        <br />
        {addressLine2}
        <br />
        {CountryName}
        <br />
        {PostalCode}
      </Typography>
    </StackAtom>
  )
})`
  ${addressStyles};
`
export default AddressAtom
